import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import { LinkPreviewIcon } from "../../atoms/Iconography";

import "./index.scss";

const PostLinkPreview = ({ href, className = "" }) => {
    let hostname = href;
    try {
        hostname = new URL(href).hostname.replace(/^www\./i, "");
    } catch (error) {
        // keep href as-is
    }

    return (
        <a
            className={classNames("post-link-preview", className)}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
        >
            <span className="post-link-preview__icon" aria-hidden="true">
                <LinkPreviewIcon />
            </span>
            <span className="post-link-preview__body">
                <span className="post-link-preview__label">Featured link</span>
                <span className="post-link-preview__host">{hostname}</span>
            </span>
            <span className="post-link-preview__arrow" aria-hidden="true">↗</span>
        </a>
    );
};

PostLinkPreview.propTypes = {
    href: PropTypes.string.isRequired,
    className: PropTypes.string,
};

PostLinkPreview.defaultProps = {
    className: "",
};

export default PostLinkPreview;
